module.exports = __webpack_public_path__ + "static/img/history_for_summarize_bg.eda6d68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/history_for_summarize_bg.jpg
// module id = NVPO
// module chunks = 3